var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from "vue-property-decorator";
import { Dependencies } from '~/core/decorator';
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service.ts';
import { State, namespace } from "vuex-class";
import { MENU_CHANNEL } from "~/config/enum.config";
var CollectionExecutionModule = namespace('collection-execution');
var CloseCaseStep = /** @class */ (function (_super) {
    __extends(CloseCaseStep, _super);
    function CloseCaseStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            legalStatus: "CLOSING_CASE",
            id: "",
            closeCaseCause: "",
            advanceAmount: "",
            costAmount: "",
            backAmount: "",
            differenceAmount: "",
            closeCaseRemark: "",
        };
        _this.rules = {
            closeCaseCause: [{ required: true, message: "请选择结案原因" }],
        };
        _this.submitLoading = false;
        return _this;
    }
    Object.defineProperty(CloseCaseStep.prototype, "isShow", {
        get: function () {
            var _this = this;
            var arr = [MENU_CHANNEL.Legal_personal, MENU_CHANNEL.Legal_team, MENU_CHANNEL.Assist_legal];
            if (arr.find(function (v) { return _this.menuChannel === v; })) {
                // 添加催记显示保存按钮 或编辑催记 与该登录用户一致显示
                if (!this.operatorId || this.operatorId === this.userData.id)
                    return true;
                else
                    return false;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CloseCaseStep.prototype.nextStepEmit = function () { };
    CloseCaseStep.prototype.previousStepEmit = function () { };
    CloseCaseStep.prototype.emitSuccess = function () {
        if (this.id) {
            this.showLegalInfoById(this.id);
        }
        else {
            // this.showLegalInfo();
        }
    };
    CloseCaseStep.prototype.mounted = function () {
        if (this.id) {
            this.showLegalInfoById(this.id);
        }
        else {
            // this.showLegalInfo();
        }
    };
    CloseCaseStep.prototype.showLegalInfoById = function (val) {
        var _this = this;
        this.caseOperatorPageService
            .queryCaseLegalRecordById(val)
            .subscribe(function (data) {
            if (data) {
                _this.formData.id = data.id;
                _this.formData.closeCaseCause = data.closeCaseCause;
                _this.formData.advanceAmount = data.advanceAmount;
                _this.formData.costAmount = data.costAmount;
                _this.formData.backAmount = data.backAmount;
                _this.formData.differenceAmount = data.differenceAmount;
                _this.formData.closeCaseRemark = data.closeCaseRemark;
            }
        }, function (err) {
        });
    };
    CloseCaseStep.prototype.showLegalInfo = function () {
        var _this = this;
        //查询上一条催记是否结案，回显数据
        this.caseOperatorPageService
            .queryUnClossCaseLegalRecord(this.caseId)
            .subscribe(function (data) {
            if (data) {
                _this.formData.id = data.id;
            }
        }, function (err) {
        });
    };
    CloseCaseStep.prototype.submit = function () {
        var _this = this;
        var form = this.$refs["close-case-step-form"];
        form.validate(function (valid) {
            if (!valid)
                return false;
            if (_this.menuChannel === MENU_CHANNEL.Assist_legal) {
                _this.formData.assistId = _this.otherData.assistId;
            }
            _this.formData.caseId = _this.caseId;
            _this.caseOperatorPageService
                .addCaseLegalRecord(_this.formData)
                .subscribe(function (data) {
                form.resetFields();
                _this.formData.id = "";
                _this.emitSuccess();
                _this.$message.success('法催催记立案已添加成功，如需修改请在法务详情中进行修改');
            }, function (err) {
                _this.submitLoading = false;
            });
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], CloseCaseStep.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CloseCaseStep.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CloseCaseStep.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CloseCaseStep.prototype, "otherData", void 0);
    __decorate([
        Prop({ type: String, required: false })
    ], CloseCaseStep.prototype, "id", void 0);
    __decorate([
        Prop({ type: String })
    ], CloseCaseStep.prototype, "operatorId", void 0);
    __decorate([
        State
    ], CloseCaseStep.prototype, "userData", void 0);
    __decorate([
        Emit('nextStep')
    ], CloseCaseStep.prototype, "nextStepEmit", null);
    __decorate([
        Emit('previousStep')
    ], CloseCaseStep.prototype, "previousStepEmit", null);
    __decorate([
        Emit('emitSuccess')
    ], CloseCaseStep.prototype, "emitSuccess", null);
    CloseCaseStep = __decorate([
        Component({
            components: {}
        })
    ], CloseCaseStep);
    return CloseCaseStep;
}(Vue));
export default CloseCaseStep;
